import attendances from 'translations/fr/manager/attendances'
import audit from 'translations/fr/manager/audit'
import availabilities from 'translations/fr/manager/availabilities'
import bulletins from 'translations/fr/manager/bulletins'
import contactLists from 'translations/fr/manager/contactLists'
import dashboard from 'translations/fr/manager/dashboard'
import imports from 'translations/fr/manager/imports'
import punch from 'translations/fr/manager/punch'
import projects from 'translations/fr/manager/projects'
import reports from 'translations/fr/manager/reports'
import schedule from 'translations/fr/manager/schedule'
import scheduleCapacity from 'translations/fr/manager/scheduleCapacity'
import scheduleIssues from 'translations/fr/manager/scheduleIssues'
import scheduleTemplates from 'translations/fr/manager/scheduleTemplates'
import timeOffs from 'translations/fr/manager/timeOffs'
import users from 'translations/fr/manager/users'

export default {
  ATTENDANCES: `Absences`,
  AUDIT: `Audit`,
  AVAILABILITIES: `Disponibilités`,
  BULLETINS: `Babillard`,
  CONTACT: `Listes de contact`,
  CONTACT_LISTS: `Listes de contact`,
  DASHBOARD: `Tableau de bord`,
  PUNCH: `Cartes de temps`,
  PROJECTS: `Projets`,
  USER_LIST: `Utilisateurs`,
  SCHEDULE: `Horaire`,
  SCHEDULE_TEMPLATES: `Modèles d'horaire`,
  TIME_OFFS: `Congés`,
  TIMEOFF: `Congés`,
  REPORTS_LIST: `Rapports`,
  REPORTS: `Rapports`,
  TEMPLATES: `Modèles`,
  USERS: `Utilisateurs`,
  VALIDATION: `Validation`,
  POSITIONS: `Positions`,
  COST_WARNING: `Des frais additionnels peuvent s'appliquer.`,
  NAV: {
    OTHER: `Autres`,
    MANAGE_FAVORITES: `Gérer mes liens favoris`,
    FAVORITES_MODAL: {
      TITLE: `Liens favoris`,
      SUMMARY: `Cette interface vous permet de changer les liens qui apparaissent en haut du portail gestionnaire.`,
      TOO_MANY_FAVORITES: `Vous avez sélectionné beaucoup de favoris! Afin de les afficher correctement, seules les icônes apparaîtront dans la barre de navigation.`
    }
  },
  breadcumbs: {
    ACTIVE: 'Page actuelle'
  },
  SAVED_PRESET_MODAL: {
    TITLE: `Sauvegarder la recherche`,
    SUMMARY: `Vous pouvez sauvegarder la recherche actuelle afin de la retrouver facilement dans le futur.`,
    NAME_REQUIRED: 'Le nom de la recherche est requis',
    NAME: {
      LABEL: `Nom`,
      PLACEHOLDER: `Entrer un nom pour cette recherche`,
      DESCRIPTION: ''
    }
  },
  attendances,
  audit,
  availabilities,
  bulletins,
  contactLists,
  dashboard,
  imports,
  punch,
  projects,
  reports,
  schedule,
  scheduleCapacity,
  scheduleIssues,
  scheduleTemplates,
  timeOffs,
  users
}
